export default __webpack_public_path__ + "static/media/kitchen3-afterD-768w.6cdde5f1.webp";